
<div class="content" id="permitApproval">
  <div class="container-fluid Confirmation-invoice" >
    <div class="col-md-12" *ngIf="isLoading">
      <app-busy [message]="message"></app-busy>
    </div>
      <div class="content">
        <h4>
          <span style="padding-right:5px"></span>
         
          <b>Permit Approval {{headingMsg}}</b>
          <div class="rectangle-34"></div>
        </h4>
      <div class="confirmation-block">
          <div class="col-md-12 p-0 mt-3">
            <!-- <ngx-loading [show]="gridload"></ngx-loading> -->
            <div class="row">
             <div style="margin-bottom:10px; margin-left:10px">
              
            </div>
          </div>
         

          <table class="table-1" id="pdfTable-1" *ngIf="approvalRes!=null">
              <table style="margin-left:70px; width: 50%; display: inline-block">
              <tr style="height: 35px"><span ><b>Carrier Code : </b></span><span class="pl-0">{{approvalRes.carrier.carrier_code}}</span></tr>
                <tr style="height: 35px"><span><b>Carrier Name :</b> </span><span class="pl-0">{{approvalRes.carrier.name}}</span></tr>
              <tr style="height: 35px"><span><b>Registration No : </b></span><span class="pl-0">{{approvalRes.carrier.registration_number}}</span></tr>
          </table>
          <table style="width: 40%; display: inline-block">
              <tr style="height: 35px"><span><b>Permit Type : </b></span><span class="pl-0">{{approvalRes.permit_type.description}}</span></tr>
               <tr style="height: 35px"> <span><b>Date Submitted : </b></span><span class="pl-0">{{approvalRes.submission_date | date:'dd/MM/yyyy'}}</span></tr>
               <tr style="height: 35px"> <span><b>Permit Status : </b></span><span class="pl-0" *ngIf="status">{{status.description}}</span></tr>
          </table>
            
            <tr *ngIf="addInfo == false">
              <td colspan="4">
                <span style="margin-bottom: 100px;"><b>Change Permit application Status to </b></span><br/>
                 <span>
                   <select  [(ngModel)]="approvalRes.status_id" class="form-control select-auto" (change)="statusUpdate()"  id="permit_status">
                     <option value="null">Select Status</option>
                      <ng-container *ngIf="approvalRes.status_id">
                          <option *ngFor="let c of statuses" [ngValue]="c.id">
                            {{c.description}}
                          </option>
                      </ng-container>
                      <ng-container *ngIf="approvalRes.status_id">
                        <ng-container *ngFor="let c of statuses">
                        <option *ngIf="c.id" [ngValue]="c.id">
                          {{c.description}}
                        </option>
                        </ng-container>
                    </ng-container>
                   </select>
                 </span>
              </td>
             </tr>
            <tr>
               <td colspan="4">
                <span class="head-text"><b>Email to be sent to </b></span> <span class="pl-0">{{approvalRes.carrier.email}}</span><br/>
                <!-- <ckeditor  [(ngModel)]="description" (input)="changes()" debounce="100">
                </ckeditor> -->
                <quill-editor [styles]="{height: '400px'}"  [(ngModel)]="description"
              [modules]="quillConfig"  (onEditorCreated)="changes()">
            </quill-editor>
               </td>
             </tr>
             <tr>
               <td colspan="4">
                <div class="crpdnce-left"><b>Send correspondence to </b></div>
                <div class="crpdnce-right">
                  <span class="pl-0"><input type="checkbox" (click)="selectUser(emailContacts.LeadUser)" name="permitLead" class="right-check" value=""/> Lead User <br/></span>
                  <span class="pl-0"><input type="checkbox" [disabled]="emailContacts.MainContact==null" (click)="selectUser(emailContacts.MainContact)" name="permitMain" class="right-check" value=""/> Main Contact  <br/></span>
                  <span class="pl-0"><input type="checkbox" [disabled]="emailContacts.Owner==null"  (click)="selectUser(emailContacts.Owner)" name="permitOwner" class="right-check"   value=""/> Owner <br/></span>
                 </div>
               </td>
             </tr>
           </table>
           <div class="col-md-12 p-0" style="margin-top: -40px">
              <button (click)="onSAveAndSend()" title="Save and Send" name="save" type="submit" id="btnSave" [disabled]="crspdType==''" class="btn btn-md m-clr pull-right hd-btn" style="color: white !important; width:180px; margin-right:10px;margin-bottom:5px;float:right;">Save & Send</button>
              <button (click)="redirectList()" title="Cancel"  name="cancel" type="submit" id="btnSave"  class="btn btn-md m-clr m-clr pull-right hd-btn mr-2" style="background-color: white !important;border: 1px solid var(--sapphire);color: var(--sapphire) !important;width:180px; margin-right:0px;margin-bottom:5px;float:right;">Close</button>

            </div>
          </div>
        </div>
        </div>
        <!--<div class="col-md-12 p-0" id="ignoreContent">
          <button title="Download PDF" name="download" type="submit" id="btnSave" (click)="downloadPdf()"  class="btn btn-md m-clr pull-right hd-btn" style="width:auto; margin-right:0px;margin-bottom:5px;  ">Download PDF</button>
      </div>-->
    </div>
  </div>
